import { useCallback } from 'react';

import useEnum from '@hooks/useEnum';

import ProcessoService from '@services/ProcessoService';

const useStatusCartao = () => {
    const fetch = useCallback(() => ProcessoService.listarStatusCartoes(), []);
    const { data, loading, error } = useEnum(fetch);

    return { data, loading, error };
}

export default useStatusCartao;
;